
import { formatNumber } from "@/static/utils";
import { Loan } from "@/models/Loan";
import { PropType } from "vue";
export default {
  props: {
    loan: {
      type: Object as PropType<Loan>,
    },
  },
  setup() {
    return { formatNumber };
  },
};
